// extracted by mini-css-extract-plugin
export default {"outer-link":"outer-link_outer-link__dUx3r"};